import constants from "src/constants";
import Script from "next/script";
import { useRouter } from "next/router";

const ThirdPartyScripts = () => {
  const { asPath } = useRouter();
  const isCart = asPath === constants.Paths.pageCart;

  return (
    <>
      {process.env.NODE_ENV !== "development" && (
        <>
          {/* Facebook Pixel Code */}
          <Script id="fb-pixel" strategy="afterInteractive">
            {`
              !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '300079365168860');fbq('track', 'PageView');
            `}
          </Script>

          {/* Google Tag Manager */}
          <Script id="gtm" strategy="afterInteractive">
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${constants.Marketing.gtmId}');
            `}
          </Script>

          {/* Global Site Tag (gtag.js) - Google Analytics */}
          <Script
            strategy="afterInteractive"
            src={`https://www.googletagmanager.com/gtag/js?id=${constants.Marketing.gaId}`}
          />

          <Script id="gtag" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${constants.Marketing.gaId}');
            `}
          </Script>

          {/* Posthog */}
          <Script id="posthog" strategy="afterInteractive">
            {`
              !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
              posthog.init('phc_m7yOwlJxc0ENnAngk6j3R8hycDhC5t6quoYdtjpsyPh',{api_host:'https://app.posthog.com'})
            `}
          </Script>

          {/* PayU  */}
          {isCart && (
            <Script
              strategy="beforeInteractive"
              src={`https://secure.payu.com/javascript/sdk`}
            />
          )}
        </>
      )}
      {process.env.NODE_ENV === "development" && (
        <>
          {/* PayU  */}
          {isCart && (
            <Script
              strategy="beforeInteractive"
              src={`https://secure.snd.payu.com/javascript/sdk`}
            />
          )}
        </>
      )}
    </>
  );
};

export default ThirdPartyScripts;
